import PlayersPointsFilters from "./PlayersPointsFilters";

export default class FantasyPlayersMetaModel {
  public filters: PlayersPointsFilters = new PlayersPointsFilters();
}
